class RampThemes {
    static GetDarkMode() {
        let isDarkMode = localStorage.getItem("rampa_DarkMode");

        if (isDarkMode == null)
            isDarkMode = "false";

        return isDarkMode === "true" ? true : false;
    }

    static GetLiteMode() {
        let isLiteMode = localStorage.getItem("rampa_LiteMode");

        if (isLiteMode == null)
            isLiteMode = "false";

        return isLiteMode === "true" ? true : false;
    }

    static SetDarkMode(mode) {
        localStorage.setItem("rampa_DarkMode", mode ? "true" : "false");
    }

    static SetLiteMode(mode) {
        localStorage.setItem("rampa_LiteMode", mode ? "true" : "false");
    }

    static PrefersDarkMode() {
        return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    }

    static PrefersLightMode() {
        return window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches;
    }

    static ApplyColorScheme() {
        if (RampThemes.GetDarkMode()) {
            let style = document.documentElement.style;
            style.setProperty("--btn", "rgb(45, 45, 45)");
            style.setProperty("--btn_active", "rgb(60, 60, 60)");
            style.setProperty("--btn_disabled", "rgb(0, 0, 0)");
            style.setProperty("--btn_text", "rgb(230, 230, 230)");
        }
    }
}

export default RampThemes;